module.exports = __webpack_public_path__ + "img/app-slm.84b1545d.jpg";